<template>
  <div class="py-4">
    <label
      class="group flex w-full"
      :class="[
        disabled ? 'pointer-events-none text-grey-mid' : 'cursor-pointer',
      ]"
    >
      <input
        v-model="checked"
        type="checkbox"
        class="peer pointer-events-none absolute z-10 h-32 w-32 appearance-none rounded-md checked:!bg-transparent focus-visible:outline-2 focus-visible:-outline-offset-1"
        :disabled="disabled"
        :value="value"
      />

      <div
        class="inline h-32 w-32 rounded-md border border-grey-dark-01 p-2 text-white group-hover:text-grey-mid peer-checked:bg-grey-dark-01 peer-checked:!text-white peer-focus-visible:text-grey-mid"
        :class="{
          'border-grey-mid': disabled,
          'border-[#BF342D]': error,
        }"
      >
        <SpriteSymbol
          name="check"
          alt="check"
          class="h-full w-full text-current"
        />
      </div>
      <div class="pl-16 leading-loose">{{ title }}</div>
    </label>
    <div v-if="error" class="mt-10 block text-xs text-[#BA251E]">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string
    disabled?: boolean
    name: string
    value?: string
    error?: string
  }>(),
  {
    disabled: false,
    value: undefined,
    error: undefined,
  },
)

const checked = defineModel<boolean | string[]>()
</script>
